<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-100">
            <md-field
              :class="[
                { 'md-valid': !errors.has('practice') && touched.practice },
                { 'md-form-group': true },
                { 'md-error': errors.has('practice') }
              ]"
            >
              <md-icon>business</md-icon>
              <label>Name: Business / Practice</label>
              <md-input
                v-validate="'required'"
                v-model="practice"
                data-vv-name="practice"
                type="text"
                name="practice"
              />
              <slide-y-down-transition>
                <md-icon v-show="errors.has('practice')" class="error">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon v-show="!errors.has('practice') && touched.practice" class="success">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </div>

          <div class="md-layout-item md-size-100">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-60">
                <md-field
                  :class="[
                    { 'md-valid': !errors.has('address') && touched.address },
                    { 'md-form-group': true },
                    { 'md-error': errors.has('address') }
                  ]"
                >
                  <md-icon>location_on</md-icon>
                  <label>Address</label>
                  <md-input
                    v-validate="'required'"
                    v-model="address"
                    data-vv-name="address"
                    type="text"
                    name="address"
                  />
                  <slide-y-down-transition>
                    <md-icon v-show="errors.has('address')" class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon v-show="!errors.has('address') && touched.address" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>

              <div class="md-layout-item">
                <md-field
                  :class="[
                    { 'md-valid': !errors.has('city') && touched.city },
                    { 'md-form-group': false },
                    { 'md-error': errors.has('city') }
                  ]"
                >
                  <!--<md-icon>location_city</md-icon>-->
                  <label>City</label>
                  <md-input v-validate="'required'" v-model="city" data-vv-name="city" type="text" name="city" />
                  <slide-y-down-transition>
                    <md-icon v-show="errors.has('city')" class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon v-show="!errors.has('city') && touched.address" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>
            </div>
          </div>

          <div class="md-layout-item md-size-100">
            <div class="md-layout md-gutter">
              <div
                :class="[
                  { 'md-layout-item': true },
                  { 'space-right-phone': true },
                  { 'md-size-40': isPhone },
                  { 'md-size-30': !isPhone }
                ]"
                @click="focus('state')"
              >
                <md-field
                  :class="[
                    { 'md-valid': !errors.has('State') && touched.state },
                    { 'md-form-group': true },
                    { 'md-error': errors.has('State') }
                  ]"
                  @click.native="stateClearFilter"
                  @keydown.native="stateFind($event)"
                >
                  <md-icon>outlined_flag</md-icon>
                  <label>State</label>
                  <md-select
                    v-validate="'required'"
                    v-if="stateSwitch"
                    id="state-select"
                    ref="stateInput"
                    v-model="state"
                    style="margin-left: 20px"
                    data-vv-name="State"
                    type="text"
                    name="State"
                    md-dense
                    @keydown.native="stateFind($event)"
                  >
                    <md-option
                      v-for="(state, index) in states"
                      :key="state.LookupId"
                      :id="state + '-state'"
                      :value="state.LookupId"
                      :md-value="state"
                      >{{ state.DisplayValue }}</md-option
                    >
                  </md-select>
                  <slide-y-down-transition>
                    <md-icon v-show="errors.has('State')" class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon v-show="!errors.has('State') && touched.address" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>

              <div class="md-layout-item md-size-20">
                <md-field
                  :class="[
                    { 'md-valid': !errors.has('zip') && touched.zip },
                    { 'md-form-group': false },
                    { 'md-error': errors.has('zip') }
                  ]"
                >
                  <!--<md-icon>location_on</md-icon>-->
                  <label class="spaced-phone-label">Zip-Code</label>
                  <md-input
                    v-validate="'required'"
                    ref="zipCodeInput"
                    v-model="zip"
                    data-vv-name="zip"
                    type="text"
                    name="zip"
                  />
                  <slide-y-down-transition>
                    <md-icon v-show="errors.has('zip')" class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon v-show="!errors.has('zip') && touched.address" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>

              <div class="md-layout-item" @click="focus('country')">
                <md-field
                  v-if="countrySwitch"
                  :class="[
                    { 'md-valid': !errors.has('country') && touched.country },
                    { 'md-form-group': false },
                    { 'md-error': errors.has('country') }
                  ]"
                  @click.native="countryClearFilter"
                  @keydown.native="countryFind($event)"
                >
                  <!--<md-icon>outlined_flag</md-icon>-->
                  <label>Country</label>
                  <md-select
                    v-validate="'required'"
                    id="country-select"
                    ref="countryInput"
                    v-model="country"
                    data-vv-name="country"
                    type="text"
                    name="country"
                    md-dense
                  >
                    <md-option
                      v-for="(country, index) in countries"
                      :key="index"
                      :value="country.LookupId"
                      :id="country"
                      >{{ country.DisplayValue }}
                    </md-option>
                  </md-select>
                  <slide-y-down-transition>
                    <md-icon v-show="errors.has('country')" class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon v-show="!errors.has('country') && touched.country" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>
            </div>
          </div>

          <div class="md-layout-item md-size-100">
            <div class="md-layout md-gutter">
              <div :class="[{ 'md-layout-item': true }, { 'md-size-70': isPhone }, { 'md-size-40': !isPhone }]">
                <md-field
                  :class="[
                    { 'md-valid': !errors.has('bizphone') && touched.bizphone },
                    { 'md-form-group': true },
                    { 'md-error': errors.has('bizphone') }
                  ]"
                >
                  <md-icon>phone</md-icon>
                  <label class="spaced-phone-label">Business Phone</label>
                  <md-input
                    v-mask="bizphoneMask"
                    v-validate="'required'"
                    v-if="bizphoneSwitch"
                    ref="bizphoneInput"
                    v-model="bizphone"
                    data-vv-name="bizphone"
                    class="dense-phone-input"
                    type="text"
                    name="bizphone"
                  />
                  <slide-y-down-transition>
                    <md-icon v-show="errors.has('bizphone')" class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon v-show="!errors.has('bizphone') && touched.bizphone" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>

              <div class="md-layout-item">
                <md-field
                  :class="[
                    { 'md-valid': !errors.has('website') && touched.website },
                    { 'md-form-group': false },
                    { 'md-error': errors.has('website') }
                  ]"
                >
                  <!--<md-icon>location_city</md-icon>-->
                  <label>Web Address</label>
                  <md-input
                    v-validate="modelValidations.website"
                    v-model="website"
                    data-vv-name="website"
                    type="text"
                    name="website"
                  />
                  <slide-y-down-transition>
                    <md-icon v-show="errors.has('website')" class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon v-show="!errors.has('website') && touched.website" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>
            </div>

            <hr style="width: 100%; border-color: #1565c0; margin-top: 25px; margin-bottom: 20px" />
          </div>

          <div class="md-layout-item md-size-100">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-45">
                <md-field
                  :class="[
                    { 'md-valid': !errors.has('language') && touched.language },
                    { 'md-form-group': true },
                    { 'md-error': errors.has('language') }
                  ]"
                >
                  <md-icon>language</md-icon>
                  <label class="spaced-phone-label">Languages spoken</label>
                  <md-input v-model="language" data-vv-name="language" type="text" name="language" />
                  <slide-y-down-transition>
                    <md-icon v-show="errors.has('language')" class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon v-show="!errors.has('language') && touched.language" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>

              <div class="md-layout-item" style="padding: 0px">
                <div class="md-inline-checkboxes" style="line-height: 10px; font-size: 0.75rem">
                  <div class="modify-checkbox">
                    <md-checkbox v-for="(item, index) in languagesList" :key="item.LookupId" v-model="item.selected">{{
                      item.DisplayValue
                    }}</md-checkbox>
                    <md-checkbox v-model="chk_OtherLang">Other</md-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="md-layout-item md-size-100" style="margin-top: 10px">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-45">
                <md-field
                  :class="[
                    {
                      'md-valid': !errors.has('insurance') && touched.insurance
                    },
                    { 'md-form-group': true },
                    { 'md-error': errors.has('insurance') }
                  ]"
                >
                  <md-icon>credit_card</md-icon>
                  <label class="spaced-phone-label">Insurance accepted</label>
                  <md-input
                    v-validate="modelValidations.insurance"
                    v-model="insurance"
                    data-vv-name="insurance"
                    type="text"
                    name="insurance"
                  />
                  <slide-y-down-transition>
                    <md-icon v-show="errors.has('insurance')" class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon v-show="!errors.has('insurance') && touched.insurance" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>

              <div class="md-layout-item" style="padding: 0px">
                <div class="md-inline-checkboxes" style="line-height: 10px; font-size: 0.75rem">
                  <div class="modify-checkbox">
                    <md-checkbox v-for="(item, index) in insurancesList" :key="item.LookupId" v-model="item.selected">{{
                      item.DisplayValue
                    }}</md-checkbox>
                    <md-checkbox v-model="chk_OtherIns">Other</md-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { IconCheckbox } from "@/components"
import { SlideYDownTransition } from "vue2-transitions"
import { mapGetters, mapActions } from "vuex"
import $ from "jquery"
export default {
  components: {
    IconCheckbox,
    SlideYDownTransition
  },
  data() {
    return {
      countries: "",
      states: [],
      insurancesList: [],
      languagesList: [],
      practice: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      bizphone: "",
      bizphoneMask: "(###)###-####",
      bizphoneSwitch: true,
      stateSwitch: true,
      countrySwitch: true,
      website: "",
      language: "",
      insurance: "",
      chk_En: false,
      chk_Sp: false,
      chk_Fr: false,
      chk_OtherLang: false,
      chk_CIG: false,
      chk_BC: false,
      chk_UHC: false,
      chk_OtherIns: false,
      stateFilterKeys: "",
      countryFilterKeys: "",
      selectedState: false,
      touched: {
        practice: false,
        address: false,
        city: false,
        state: false,
        zip: false,
        country: false,
        bizphone: false,
        website: false
      },
      modelValidations: {
        practice: {
          required: false,
          min: 3
        },
        address: {
          required: false,
          min: 5
        },
        city: {
          required: false,
          min: 3
        },
        state: {
          required: false,
          min: 2
        },
        zip: {
          required: false,
          min: 5
        },
        country: {
          required: false,
          min: 5
        },
        bizphone: {
          required: false,
          min: 10
        },
        website: {
          required: false,
          min: 5,
          regex: "^[0-9a-zA-Z/:\\.]+\\.[a-zA-Z]{3}$|^[0-9a-zA-Z/:\\.]+\\.[a-zA-Z]{2}$"
        }
      }
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.defineLookups()
  },
  computed: {
    ...mapGetters(["drPractice", "isPhone"])
  },
  watch: {
    practice() {
      this.touched.practice = true
    },
    country() {
      this.bizphoneMask = "(###)###-####"
      this.reRenderBizphone(false)
    },
    bizphone() {
      if (!this.country || !this.country.LookupId) {
        return
      }

      let countryCode = String(this.country.value) // Ensure it's a string
      let codeCapture = this.bizphone.substring(0, countryCode.length)
      let codeCapturePlus = this.bizphone.substring(0, countryCode.length + 1)

      if (codeCapture !== countryCode && codeCapturePlus !== "+" + countryCode) {
        if (this.bizphone.includes("+")) {
          this.bizphone = ""
        }
        this.bizphone = "+" + countryCode // Ensure it starts with "+"
        this.reRenderBizphone(true)
      }
    }
  },
  methods: {
    ...mapActions(["listLookupsByMasterName"]),
    updateSelectedLookups(lookupList, storedIds) {
      if (storedIds.length > 0) {
        return lookupList.map(lookup => ({
          ...lookup,
          selected: storedIds.includes(lookup.LookupId.toString())
        }))
      } else {
        return lookupList
      }
    },
    fetchLookupByName(name) {
      return this.listLookupsByMasterName(name)
    },
    nameToLookup(lookupList, id) {
      let lookupItem = lookupList.find(item => item.LookupId === +id)
      if (lookupItem) {
        return lookupItem.LookupId
      } else {
        return null
      }
    },
    async defineLookups() {
      try {
        this.states = await this.fetchLookupByName("States")
        this.countries = await this.fetchLookupByName("CountryCodes")
        const languages = await this.fetchLookupByName("Languages")
        const insurances = await this.fetchLookupByName("Insurance")

        const usaCountry = this.countries.find(country => country.DisplayValue === "United States of America")
        if (usaCountry) {
          this.country = usaCountry.LookupId
        }

        this.insurancesList = insurances.map(i => ({ ...i, selected: false }))
        this.languagesList = languages.map(i => ({ ...i, selected: false }))
        this.fillPracticeData()
      } catch (error) {
        console.error("Error fetching lookups:", error)
      }
    },
    reRenderBizphone(focus) {
      this.bizphoneSwitch = false

      this.$nextTick(() => {
        this.bizphoneSwitch = true
        if (focus) {
          this.$nextTick(() => {
            this.$refs.bizphoneInput.$el.focus()
          })
        }
      })
    },
    fillPracticeData() {
      if (!this.isEdit) return
      this.practice = this.drPractice.bizName || ""
      this.website = this.drPractice.website || ""
      this.bizphone = this.drPractice.phone || ""
      this.address = this.drPractice.address || ""
      this.city = this.drPractice.city || ""
      this.state = this.nameToLookup(this.states, this.drPractice.state) || ""
      this.zip = this.drPractice.zip || ""
      this.country = this.nameToLookup(this.countries, this.drPractice.country) || ""

      // Extract stored languages
      if (this.drPractice.languages === null) {
        this.drPractice.languages = ""
      }
      const isOtherFlow = this.drPractice.languages.includes(";Other;")
      let storedLanguages = []
      if (!isOtherFlow) {
        this.chk_OtherLang = ""
        const isMultiple = this.drPractice.languages.includes(";")
        if (isMultiple) {
          storedLanguages = this.drPractice.languages.split(";")
        } else {
          storedLanguages = [this.drPractice.languages]
        }
      }
      if (isOtherFlow) {
        storedLanguages = this.drPractice.languages.split(";Other;")[0].split(";")
        this.language = this.drPractice.languages.split(";Other;")[1]
        this.chk_OtherLang = true
      }
      this.languagesList = this.updateSelectedLookups(this.languagesList, storedLanguages)

      if (!this.drPractice.insurances) {
        this.drPractice.insurances = ""
      }
      // Extract stored insurances
      const isOtherInsFlow = this.drPractice.insurances.includes(";Other;")
      let storedInsurances = []
      if (!isOtherInsFlow) {
        this.chk_OtherIns = ""
        const isMultiple = this.drPractice.insurances.includes(";")
        if (isMultiple) {
          storedInsurances = this.drPractice.insurances.split(";")
        } else {
          storedInsurances = [this.drPractice.insurances]
        }
      }
      if (isOtherInsFlow) {
        storedInsurances = this.drPractice.insurances.split(";Other;")[0].split(";")
        this.insurance = this.drPractice.insurances.split(";Other;")[1]
        this.chk_OtherIns = true
      }
      this.insurancesList = this.updateSelectedLookups(this.insurancesList, storedInsurances)
    },

    reRenderCountry() {
      this.countrySwitch = false

      this.$nextTick(() => {
        this.countrySwitch = true
      })
    },
    reRenderState() {
      this.stateSwitch = false

      this.$nextTick(() => {
        this.stateSwitch = true
      })
    },
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    validate() {
      this.storeValues()
      return this.$validator.validateAll().then(res => {
        this.$emit("on-validated", res)
        return res
      })
    },
    storeValues() {
      this.drPractice.bizName = this.practice
      this.drPractice.website = this.website
      this.drPractice.phone = this.bizphone
      this.drPractice.address = this.address
      this.drPractice.city = this.city
      this.drPractice.state = this.state
      this.drPractice.zip = this.zip
      this.drPractice.country = this.country
      let idList = this.languagesList
        .filter(i => i.selected) // Get selected LookupId
        .map(i => i.LookupId)
      this.drPractice.languages = idList.length > 1 ? idList.join(";") : idList[0] || ""
      if (this.language != "") {
        this.drPractice.languages += `;Other;${this.language}`
      }
      idList =
        this.insurancesList
          .filter(i => i.selected) // Get selected LookupId
          .map(i => i.LookupId) || []
      this.drPractice.insurances = idList.length > 1 ? idList.join(";") : idList[0] || ""
      if (this.insurance != "") {
        this.drPractice.insurances += `;Other;${this.insurance}`
      }
    },
    stateFind(event) {
      if (event.key === "Escape") {
        this.stateFilterKeys = ""
      }
      if (event.key === "Enter") {
        this.reRenderState()
        this.$refs.zipCodeInput.$el.focus()
      }
      if (event.key.length > 1) return
      if (this.stateFilterKeys.length < 2) {
        this.stateFilterKeys += event.key.toUpperCase()
      } else {
        this.stateFilterKeys = event.key.toUpperCase()
      }
      let foundState = this.states.find(state => {
        return state.startsWith(this.stateFilterKeys)
      })
      if (!foundState) {
        this.stateFilterKeys = ""
        return
      }
      this.state = foundState
      let value = this.states.indexOf(foundState) * 43
      let stateID = $("#" + foundState + "-state")
      let scrollParent = $(stateID)
        .parent()
        .parent()
      $(scrollParent).scrollTop(value)
    },
    countryFind(event) {
      if (event.key === "Enter") {
        this.reRenderCountry()
        this.reRenderBizphone(true)
      }
      if (event.key === "Escape") {
        this.countryFilterKeys = ""
      }
      if (event.key === "Backspace") {
        this.countryFilterKeys = this.countryFilterKeys.substring(0, this.countryFilterKeys.length - 1)
      }
      if (event.key.length > 1) return

      this.countryFilterKeys += event.key

      let foundCountry = this.countries.find(country => {
        return country.DisplayValue.toLowerCase().startsWith(this.countryFilterKeys.toLowerCase())
      })

      this.country = foundCountry
      let value = this.countries.indexOf(foundCountry) * 43
      let countryID = $("#" + foundCountry)
      let scrollParent = $(countryID)
        .parent()
        .parent()

      $(scrollParent).scrollTop(value)
    },
    stateClearFilter() {
      this.stateFilterKeys = ""
    },
    countryClearFilter() {
      this.countryFilterKeys = ""
    },
    focus(type) {
      let el = $("#" + type + "-select")
      el.focus()
    }
  }
}
</script>
<style lang="scss" scoped>
.md-select menu .md-list-item .md-list-item-content {
  min-height: 25px;
}

.md-card-wizard .tab-content {
  padding: 20px, 0px;
}
</style>

<style lang="scss">
#no-side-padding {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.modify-checkbox {
  .md-checkbox-label {
    padding-left: 5px;
  }
}
</style>
